export const SettingsSvg = (color?: string) => (
	<svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			opacity="0.34"
			d="M15.7715 18.6546C17.8426 18.6546 19.5215 17.0184 19.5215 15C19.5215 12.9817 17.8426 11.3455 15.7715 11.3455C13.7004 11.3455 12.0215 12.9817 12.0215 15C12.0215 17.0184 13.7004 18.6546 15.7715 18.6546Z"
			stroke={color || '#98B2B9'}
			strokeWidth="1.82729"
			strokeMiterlimit="10"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M3.27139 16.0721V13.9281C3.27139 12.6612 4.33389 11.6135 5.64639 11.6135C7.90889 11.6135 8.83389 10.0543 7.69639 8.14169C7.04639 7.04531 7.43389 5.62003 8.57139 4.98657L10.7339 3.78056C11.7214 3.208 12.9964 3.5491 13.5839 4.51147L13.7214 4.74293C14.8464 6.65549 16.6964 6.65549 17.8339 4.74293L17.9714 4.51147C18.5589 3.5491 19.8339 3.208 20.8214 3.78056L22.9839 4.98657C24.1214 5.62003 24.5089 7.04531 23.8589 8.14169C22.7214 10.0543 23.6464 11.6135 25.9089 11.6135C27.2089 11.6135 28.2839 12.649 28.2839 13.9281V16.0721C28.2839 17.339 27.2214 18.3867 25.9089 18.3867C23.6464 18.3867 22.7214 19.946 23.8589 21.8585C24.5089 22.9671 24.1214 24.3802 22.9839 25.0137L20.8214 26.2197C19.8339 26.7922 18.5589 26.4511 17.9714 25.4888L17.8339 25.2573C16.7089 23.3447 14.8589 23.3447 13.7214 25.2573L13.5839 25.4888C12.9964 26.4511 11.7214 26.7922 10.7339 26.2197L8.57139 25.0137C7.43389 24.3802 7.04639 22.9549 7.69639 21.8585C8.83389 19.946 7.90889 18.3867 5.64639 18.3867C4.33389 18.3867 3.27139 17.339 3.27139 16.0721Z"
			stroke={color || '#98B2B9'}
			strokeWidth="1.82729"
			strokeMiterlimit="10"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
